"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var CapturePopup = /** @class */ (function () {
    function CapturePopup(data, popup) {
        this.data = data;
        this.popup = popup;
        this.isCaptureMode = true;
        this.imageType = "image/" + data.imageType;
    }
    CapturePopup.prototype.capture = function (image) {
        this.image = image;
        this.isCaptureMode = false;
        this.imageUrl = image.imageAsDataUrl;
    };
    CapturePopup.prototype.handleError = function (initError) {
        this.errorMessage = initError.message;
        console.error(initError);
    };
    CapturePopup = __decorate([
        core_1.Component({
            
            template: require('./sis-photo-capture-popup.component.html'),
            styles: [require('./sis-photo-capture-popup.component.css')]
        }),
        __param(0, core_1.Inject(material_1.MAT_DIALOG_DATA)),
        __metadata("design:paramtypes", [Object, material_1.MatDialogRef])
    ], CapturePopup);
    return CapturePopup;
}());
exports.CapturePopup = CapturePopup;
//# sourceMappingURL=sis-photo-capture-popup.component.js.map